// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"108":"e5b98d12","200":"0d74c3e9","214":"bdfae29b","226":"0aa41c96","244":"00f32e8c","291":"5c0f2a92","346":"7cadb18b","473":"a12517b2","492":"deafbd45","522":"c121dcb5","549":"aff5783b","606":"79a78ca0","727":"97a07f31","952":"38d5d31f"}[chunkId] + ".chunk.js";
};